/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_Field_ProviderInputs */

const en_byoa_field_provider = /** @type {(inputs: Byoa_Field_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI provider`)
};

const id_byoa_field_provider = /** @type {(inputs: Byoa_Field_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyedia AI`)
};

/**
* | output |
* | --- |
* | "AI provider" |
*
* @param {Byoa_Field_ProviderInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_field_provider = /** @type {((inputs?: Byoa_Field_ProviderInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_Field_ProviderInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_field_provider(inputs)
	return en_byoa_field_provider(inputs)
});